// extracted by mini-css-extract-plugin
export default {"container":"PointsIndicator_container__Jsqg6","pointer":"PointsIndicator_pointer__kLi5e","star":"PointsIndicator_star__Rd5eU"};